import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Vendedor } from "@/shared/types/vendedor";

export async function getVendedor(id: string): Promise<Vendedor> {
    await sleep(1000);
    const response = await api.get("vendedores/" + id);
    return response.data;
}

export function useGetVendedorQuery(id: string, queryConfig: QueryConfig<Vendedor> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getVendedor(id),
        queryKey: ["vendedores", id],
    })
}

export interface GetVendedorQueryProps {
    id: string,
    queryConfig?: QueryConfig<Vendedor>,
    children?: (queryResult: QueryResult<Vendedor>) => ReactNode
}

export function GetVendedorQuery({
    id,
    children,
    queryConfig
}: GetVendedorQueryProps) {
    const queryResult = useGetVendedorQuery(id, queryConfig);
    return children && children(queryResult);
}